import { useAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useCallback, useEffect, useRef } from "react";
import useFlotte, { flotteFiltersAtom } from "../hooks/useFlotte";

const useFlotteFilters = () => {
  const [flotteFilters, setFlotteFilters] = useAtom(flotteFiltersAtom);
  const resetFilters = useResetAtom(flotteFiltersAtom);
  const { actions } = useFlotte();
  const timeoutRef = useRef(null);
  // Ref pour toujours accéder à la dernière version de actions
  const actionsRef = useRef(actions);
  actionsRef.current = actions;

  // Fonction pour effectuer la recherche (stable, utilise la ref)
  const performSearch = useCallback((searchParams) => {
    actionsRef.current.onLoadFlotteList(searchParams);
  }, []);

  // Fonction de debounce (stable, utilise la ref pour performSearch)
  const debouncedSearch = useCallback((searchParams) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      performSearch(searchParams);
    }, 1000);
  }, [performSearch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    performSearch(flotteFilters);
  };

  const handleChangeFilters = (e) => {
    const { name, value } = e.target;
    const newSearch = { ...flotteFilters, [name]: value, page: 1 };
    console.log("newSearch", newSearch);
    setFlotteFilters(newSearch);
    debouncedSearch(newSearch);
  };

  const onResetSearch = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    resetFilters();
    actionsRef.current.onLoadFlotteList({});
  };

  const handleClearFilter = (filterKey) => {
    let defaultValue = "";
    if (
      ["statuts", "marques", "modeles", "finitions", "positions"].includes(
        filterKey,
      )
    ) {
      defaultValue = [];
    }

    const newSearch = { ...flotteFilters, [filterKey]: defaultValue, page: 1 };
    setFlotteFilters(newSearch);
    performSearch(newSearch);
  };

  // Nettoyer le timeout lors du démontage du composant
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    handleSubmit,
    handleChangeFilters,
    onResetSearch,
    handleClearFilter,
    flotteFilters,
  };
};

export default useFlotteFilters;
